import { Component, Input } from '@angular/core';
import { TipoValorEnum, ValorDocumento } from 'src/app/pagamento/models/pagamento';

@Component({
  selector: 'via-receitas-pagamento',
  templateUrl: './receitas-pagamento.component.html',
  styleUrls: ['./receitas-pagamento.component.css']
})
export class ReceitasPagamentoComponent {
  @Input() valoresDocumento: ValorDocumento[];
  @Input() exibirLabels: boolean = true;
  @Input() exibirSaldos: boolean = false;

  public TipoValorEnum: typeof TipoValorEnum = TipoValorEnum;
}
